import { render, staticRenderFns } from "./ProductTrustmateStars.vue?vue&type=template&id=baf8ed8e&scoped=true&"
import script from "./ProductTrustmateStars.vue?vue&type=script&lang=ts&"
export * from "./ProductTrustmateStars.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf8ed8e",
  null
  
)

export default component.exports